import type { PartialConfig } from './base';

const local: PartialConfig = {
  backend: {
    base: 'http://127.0.0.1:5000/api/v1',
  },
  google: {
    clientId: '135764768326-hdmvt17dopjgd266g7tpka6vaa75ha92.apps.googleusercontent.com',
  },
  documents: {
    base: 'https://staging-gateway.litlingo.com/api/documents',
    socket: 'wss://staging-gateway.litlingo.com/socket',
  },
};

export default local;
